export const ABOUT = "About";
export const EXPERIENCE = "Experience";
export const CONTACT = "Contact";
export const LIGHT_BG = "#f1f5f9"
export const DARK_BG = "#0F172A"
export const DARK_GRADIENT_ACCENT_CLASS = "bg-gradient-to-br from-yellow-500 from-50% to-amber-500";
export const LIGHT_GRADIENT_ACCENT_CLASS = "bg-gradient-to-br from-blue-500 from-50% to-cyan-500"
export const DARK_TEXT_ACCENT_CLASS = "dark:text-yellow-500"
export const LIGHT_TEXT_ACCENT_CLASS = "text-blue-500"
export const DARK_HOVER_ACCENT_CLASS = "hover:text-yellow-500"
export const LIGHT_HOVER_ACCENT_CLASS = "hover:text-blue-500"
